/**
 * @fileoverview Account type options configuration for GEAO banking information forms
 */

/**
 * @typedef {Object} AccountTypeOption
 * @property {string} value - The string value representing the account type ("checking" or "savings")
 * @property {string} label - The display label for the option ("Checking" or "Savings")
 * @property {string} trackingId - Static analytics option name
 */

/**
 * Frozen array of account type options for banking information form components.
 * Used in GEAO onboarding forms where account type choices need to be presented
 * as dropdown or radio button options.
 * 
 * @type {ReadonlyArray<AccountTypeOption>}
 * @constant
 * @default
 * 
 * @example
 * // Usage in a form component
 * import AccountTypeOptions from './AccountTypeOptions';
 * 
 * const SelectField = () => (
 *   <select>
 *     {AccountTypeOptions.map(option => (
 *       <option key={option.value} value={option.value}>
 *         {option.label}
 *       </option>
 *     ))}
 *   </select>
 * );
 */
export default Object.freeze([
    { value: "checking", label: "Checking", trackingId: "Checking" },
    { value: "savings", label: "Savings", trackingId: "Savings" }
]);